import React, { FC, useContext } from 'react';
import { get } from 'lodash';

import { Content, Row } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import {
  DESCRIPTION_PLACEHOLDER_TEXT,
  DESCRIPTION_LABEL_TEXT,
  NodeProps,
} from 'src/presentation/components/pages/ivr/constants/ivrConstants';
import FormContext from 'src/presentation/contexts/FormContext';
import InputField from 'src/presentation/components/forms/InputField';
import PhoneNumberInput from 'src/presentation/components/forms/PhoneNumberInput';
import PhoneNumberTemplate from 'src/presentation/components/pages/ivr/components/nodes/components/PhoneNumberTemplate';

const ForwardNode: FC<NodeProps> = ({ attr, disabled, readOnly }) => (
  <>
    <Content>
      <Row>
        <InputField
          attr={`${attr}.name`}
          data-aid={`${attr}-name`}
          disabled={disabled}
          label="Name"
          description="The name you can refer to link to other nodes"
          readOnly={readOnly}
        />
      </Row>
      <Row>
        <InputField
          attr={`${attr}.description`}
          data-aid={`${attr}-description`}
          disabled={disabled}
          label={DESCRIPTION_LABEL_TEXT}
          placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
          readOnly={readOnly}
        />
      </Row>
      <Row>
        <PhoneNumberField
          attr={`${attr}.number.phoneNumber`}
          data-aid={`${attr}.number.phoneNumber`}
          disabled={disabled || readOnly}
          label="Phone #"
          description="The number the customer will get forwarded to"
        />
      </Row>

      <Row>
        <InputField
          attr={`${attr}.number.extension`}
          data-aid={`${attr}.number.extension`}
          description="Optional extension to dial"
          disabled={disabled}
          label="Extension"
          placeholder="Type Extension Here"
          readOnly={readOnly}
        />
      </Row>
    </Content>
  </>
);

const PhoneNumberField = ({ attr, disabled, 'data-aid': dataAid, label, description }): JSX.Element => {
  const { workingState } = useContext(FormContext);

  const isTemplate = /{{(.*)}}/g.test(get(workingState, attr, ''));

  return isTemplate ? (
    <PhoneNumberTemplate attr={attr} data-aid={dataAid} description={description} label={label} />
  ) : (
    <PhoneNumberInput attr={attr} data-aid={dataAid} disabled={disabled} label={label} description={description} />
  );
};

export default ForwardNode;
